import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from '../../../../common/services/common.service';

@Component({
  selector: 'iposcen-showon-device',
  templateUrl: './showon-device.component.html',
  styleUrls: ['./showon-device.component.scss']
})
export class ShowonDeviceComponent implements OnInit {

  @Input() buttonName: string;
  @Output() readonly show = new EventEmitter();
  @Output() readonly closePopup = new EventEmitter();
  @ViewChild('showModal') modalContent: TemplateRef<ShowonDeviceComponent>;
  direction: string;
  private modalRef: NgbModalRef;
  private modalOption: NgbModalOptions = {};

  constructor(private modalService: NgbModal,
    private cmnService: CommonService) { }

  ngOnInit(): void {
    this.direction = this.cmnService.direction;
  }

  open() {
    this.modalOption.backdrop = 'static';
    this.modalOption.keyboard = false;
    this.modalRef = this.modalService.open(this.modalContent, this.modalOption);
    this.modalRef.result.then();
  }

  close() {
    this.modalRef.close();
  }

  dismiss() {
    this.modalRef.dismiss();
  }

  ShowOnDeviceButton() {
    this.show.emit();
  }

  closeShowOnDevice() {
    this.closePopup.emit();
  }

}